import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegistrationFormComponent } from './feature/registration-form/registration-form.component';
import { SuccessScreenComponent } from './feature/success-screen/success-screen.component';
import { LogoutComponent } from './feature/logout/logout.component';
import { AccountDeletionSuccessComponent } from './feature/account-deletion-success/account-deletion-success.component';
import {ProductRegistrationComponent} from "./feature/product-registration/product-registration.component";

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'de-DE' },
  {
    path: ':isocode',
    component: RegistrationFormComponent,
  },
  {
    path: ':isocode/success',
    component: SuccessScreenComponent,
  },
  {
    path: ':isocode/logout',
    component: LogoutComponent,
  },
  {
    path: ':isocode/account-deletion',
    component: AccountDeletionSuccessComponent,
  },
  {
    path: ':isocode/product-registration',
    component: ProductRegistrationComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
